let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}


const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function addToExternrefTable0(obj) {
    const idx = wasm.__externref_table_alloc();
    wasm.__wbindgen_export_2.set(idx, obj);
    return idx;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = addToExternrefTable0(e);
        wasm.__wbindgen_exn_store(idx);
    }
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let WASM_VECTOR_LEN = 0;

const lTextEncoder = typeof TextEncoder === 'undefined' ? (0, module.require)('util').TextEncoder : TextEncoder;

let cachedTextEncoder = new lTextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedInt32ArrayMemory0 = null;

function getInt32ArrayMemory0() {
    if (cachedInt32ArrayMemory0 === null || cachedInt32ArrayMemory0.byteLength === 0) {
        cachedInt32ArrayMemory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32ArrayMemory0;
}

function getArrayI32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getInt32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

let cachedFloat32ArrayMemory0 = null;

function getFloat32ArrayMemory0() {
    if (cachedFloat32ArrayMemory0 === null || cachedFloat32ArrayMemory0.byteLength === 0) {
        cachedFloat32ArrayMemory0 = new Float32Array(wasm.memory.buffer);
    }
    return cachedFloat32ArrayMemory0;
}

function getArrayF32FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getFloat32ArrayMemory0().subarray(ptr / 4, ptr / 4 + len);
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function takeFromExternrefTable0(idx) {
    const value = wasm.__wbindgen_export_2.get(idx);
    wasm.__externref_table_dealloc(idx);
    return value;
}

let cachedUint32ArrayMemory0 = null;

function getUint32ArrayMemory0() {
    if (cachedUint32ArrayMemory0 === null || cachedUint32ArrayMemory0.byteLength === 0) {
        cachedUint32ArrayMemory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32ArrayMemory0;
}

function passArray32ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 4, 4) >>> 0;
    getUint32ArrayMemory0().set(arg, ptr / 4);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}

export function start() {
    wasm.start();
}

/**
 * @param {string} name
 */
export function greet(name) {
    const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.greet(ptr0, len0);
}

/**
 * @enum {0 | 1 | 2 | 3}
 */
export const FillType = Object.freeze({
    None: 0, "0": "None",
    Solid: 1, "1": "Solid",
    Hatch: 2, "2": "Hatch",
    Cross: 3, "3": "Cross",
});
/**
 * @enum {0 | 1}
 */
export const StrokeType = Object.freeze({
    None: 0, "0": "None",
    Solid: 1, "1": "Solid",
});

const AppFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_app_free(ptr >>> 0, 1));

export class App {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(App.prototype);
        obj.__wbg_ptr = ptr;
        AppFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AppFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_app_free(ptr, 0);
    }
    /**
     * @param {string} id
     * @param {ImageBitmap} bitmap
     */
    update_image_texture(id, bitmap) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.app_update_image_texture(this.__wbg_ptr, ptr0, len0, bitmap);
    }
    /**
     * @returns {App}
     */
    static new() {
        const ret = wasm.app_new();
        if (ret[2]) {
            throw takeFromExternrefTable0(ret[1]);
        }
        return App.__wrap(ret[0]);
    }
    /**
     * @param {number} width
     * @param {number} height
     * @param {number} device_pixel_ratio
     */
    handle_resize(width, height, device_pixel_ratio) {
        const ret = wasm.app_handle_resize(this.__wbg_ptr, width, height, device_pixel_ratio);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    render() {
        const ret = wasm.app_render(this.__wbg_ptr);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @param {number} mode
     */
    change_cursor_draw_mode(mode) {
        const ret = wasm.app_change_cursor_draw_mode(this.__wbg_ptr, mode);
        if (ret[1]) {
            throw takeFromExternrefTable0(ret[0]);
        }
    }
    /**
     * @returns {number}
     */
    get_cursor_draw_mode() {
        const ret = wasm.app_get_cursor_draw_mode(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} event
     * @param {number} x
     * @param {number} y
     * @param {any} keys
     */
    handle_mouse(event, x, y, keys) {
        wasm.app_handle_mouse(this.__wbg_ptr, event, x, y, keys);
    }
    /**
     * @param {any} keyCombo
     * @returns {boolean}
     */
    handle_key_down(keyCombo) {
        const ret = wasm.app_handle_key_down(this.__wbg_ptr, keyCombo);
        return ret !== 0;
    }
    /**
     * @param {any} keyCombo
     */
    handle_key_up(keyCombo) {
        wasm.app_handle_key_up(this.__wbg_ptr, keyCombo);
    }
    /**
     * @param {number} delta_x
     * @param {number} delta_y
     */
    handle_wheel(delta_x, delta_y) {
        wasm.app_handle_wheel(this.__wbg_ptr, delta_x, delta_y);
    }
    /**
     * @param {number} delta
     * @param {number} x
     * @param {number} y
     */
    handle_zoom(delta, x, y) {
        wasm.app_handle_zoom(this.__wbg_ptr, delta, x, y);
    }
    /**
     * @returns {number}
     */
    get_camera_scale() {
        const ret = wasm.app_get_camera_scale(this.__wbg_ptr);
        return ret;
    }
    reset_zoom_to_100() {
        wasm.app_reset_zoom_to_100(this.__wbg_ptr);
    }
    /**
     * @returns {boolean}
     */
    can_undo() {
        const ret = wasm.app_can_undo(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    can_redo() {
        const ret = wasm.app_can_redo(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    can_move_selection_up() {
        const ret = wasm.app_can_move_selection_up(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    can_move_selection_down() {
        const ret = wasm.app_can_move_selection_down(this.__wbg_ptr);
        return ret !== 0;
    }
    move_selection_up() {
        wasm.app_move_selection_up(this.__wbg_ptr);
    }
    move_selection_to_top() {
        wasm.app_move_selection_to_top(this.__wbg_ptr);
    }
    move_selection_down() {
        wasm.app_move_selection_down(this.__wbg_ptr);
    }
    move_selection_to_bottom() {
        wasm.app_move_selection_to_bottom(this.__wbg_ptr);
    }
    /**
     * @returns {number}
     */
    get_selection_count() {
        const ret = wasm.app_get_selection_count(this.__wbg_ptr);
        return ret >>> 0;
    }
    align_selection_top() {
        wasm.app_align_selection_top(this.__wbg_ptr);
    }
    align_selection_bottom() {
        wasm.app_align_selection_bottom(this.__wbg_ptr);
    }
    align_selection_left() {
        wasm.app_align_selection_left(this.__wbg_ptr);
    }
    align_selection_right() {
        wasm.app_align_selection_right(this.__wbg_ptr);
    }
    distribute_selection_horizontally() {
        wasm.app_distribute_selection_horizontally(this.__wbg_ptr);
    }
    distribute_selection_vertically() {
        wasm.app_distribute_selection_vertically(this.__wbg_ptr);
    }
    handle_undo() {
        wasm.app_handle_undo(this.__wbg_ptr);
    }
    handle_redo() {
        wasm.app_handle_redo(this.__wbg_ptr);
    }
    save() {
        wasm.app_save(this.__wbg_ptr);
    }
    fit_scene_to_viewport() {
        wasm.app_fit_scene_to_viewport(this.__wbg_ptr);
    }
    /**
     * @returns {number}
     */
    begin_export_scene_png() {
        const ret = wasm.app_begin_export_scene_png(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {boolean} background_enabled
     * @param {string} background_color
     * @param {number} padding
     * @param {number} scale
     * @returns {number}
     */
    begin_export_scene_png_with_options(background_enabled, background_color, padding, scale) {
        const ptr0 = passStringToWasm0(background_color, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.app_begin_export_scene_png_with_options(this.__wbg_ptr, background_enabled, ptr0, len0, padding, scale);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    export_scene_png_total_tiles() {
        const ret = wasm.app_export_scene_png_total_tiles(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {number}
     */
    export_scene_png_rendered_tiles() {
        const ret = wasm.app_export_scene_png_rendered_tiles(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @returns {boolean}
     */
    is_export_scene_png_active() {
        const ret = wasm.app_is_export_scene_png_active(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {number} max_tiles
     * @returns {number}
     */
    export_scene_png_render_step(max_tiles) {
        const ret = wasm.app_export_scene_png_render_step(this.__wbg_ptr, max_tiles);
        return ret;
    }
    /**
     * @returns {HTMLCanvasElement | undefined}
     */
    complete_export_scene_png_canvas() {
        const ret = wasm.app_complete_export_scene_png_canvas(this.__wbg_ptr);
        return ret;
    }
    cancel_export_scene_png() {
        wasm.app_cancel_export_scene_png(this.__wbg_ptr);
    }
    /**
     * @returns {HTMLCanvasElement | undefined}
     */
    export_scene_png_canvas() {
        const ret = wasm.app_export_scene_png_canvas(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {boolean} background_enabled
     * @param {string} background_color
     * @param {number} padding
     * @param {number} scale
     * @returns {HTMLCanvasElement | undefined}
     */
    export_scene_png_canvas_with_options(background_enabled, background_color, padding, scale) {
        const ptr0 = passStringToWasm0(background_color, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.app_export_scene_png_canvas_with_options(this.__wbg_ptr, background_enabled, ptr0, len0, padding, scale);
        return ret;
    }
    /**
     * @returns {string | undefined}
     */
    export_scene_png() {
        const ret = wasm.app_export_scene_png(this.__wbg_ptr);
        let v1;
        if (ret[0] !== 0) {
            v1 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v1;
    }
    /**
     * @param {boolean} background_enabled
     * @param {string} background_color
     * @param {number} padding
     * @param {number} scale
     * @returns {string | undefined}
     */
    export_scene_png_with_options(background_enabled, background_color, padding, scale) {
        const ptr0 = passStringToWasm0(background_color, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.app_export_scene_png_with_options(this.__wbg_ptr, background_enabled, ptr0, len0, padding, scale);
        let v2;
        if (ret[0] !== 0) {
            v2 = getStringFromWasm0(ret[0], ret[1]).slice();
            wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
        }
        return v2;
    }
    /**
     * @returns {string}
     */
    get_selection_type() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.app_get_selection_type(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {Style | undefined}
     */
    get_selection_style() {
        const ret = wasm.app_get_selection_style(this.__wbg_ptr);
        return ret === 0 ? undefined : Style.__wrap(ret);
    }
    /**
     * @param {any} data
     */
    update_selection_style(data) {
        wasm.app_update_selection_style(this.__wbg_ptr, data);
    }
    /**
     * @param {string} text
     * @param {number} x
     * @param {number} y
     */
    create_text_node(text, x, y) {
        const ptr0 = passStringToWasm0(text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.app_create_text_node(this.__wbg_ptr, ptr0, len0, x, y);
    }
    /**
     * 获取文字元素信息，返回 JSON 格式: { id, text, x, y }
     * @param {string} id
     * @returns {any}
     */
    get_text_element_info(id) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.app_get_text_element_info(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * 更新文字元素的内容
     * @param {string} id
     * @param {string} new_text
     */
    update_text_node(id, new_text) {
        const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(new_text, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        wasm.app_update_text_node(this.__wbg_ptr, ptr0, len0, ptr1, len1);
    }
    /**
     * @param {string} image_content_id
     * @param {number} width
     * @param {number} height
     */
    create_image(image_content_id, width, height) {
        const ptr0 = passStringToWasm0(image_content_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.app_create_image(this.__wbg_ptr, ptr0, len0, width, height);
    }
    /**
     * @param {number} length
     */
    allocate(length) {
        wasm.app_allocate(this.__wbg_ptr, length);
    }
    /**
     * @returns {number}
     */
    memory_pos() {
        const ret = wasm.app_memory_pos(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {string} ranges_json
     * @returns {number}
     */
    load_font_with_ranges(ranges_json) {
        const ptr0 = passStringToWasm0(ranges_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.app_load_font_with_ranges(this.__wbg_ptr, ptr0, len0);
        return ret >>> 0;
    }
    /**
     * @param {Uint32Array} chain
     */
    set_font_fallback_chain(chain) {
        const ptr0 = passArray32ToWasm0(chain, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.app_set_font_fallback_chain(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {boolean}
     */
    is_any_font_loaded() {
        const ret = wasm.app_is_any_font_loaded(this.__wbg_ptr);
        return ret !== 0;
    }
    on_fonts_changed() {
        wasm.app_on_fonts_changed(this.__wbg_ptr);
    }
    load_saved_data() {
        wasm.app_load_saved_data(this.__wbg_ptr);
    }
    /**
     * @returns {string}
     */
    export_editor_json() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.app_export_editor_json(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} editor_json
     * @returns {boolean}
     */
    load_editor_json(editor_json) {
        const ptr0 = passStringToWasm0(editor_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.app_load_editor_json(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * @returns {string}
     */
    export_camera_json() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.app_export_camera_json(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} camera_json
     * @returns {boolean}
     */
    load_camera_json(camera_json) {
        const ptr0 = passStringToWasm0(camera_json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.app_load_camera_json(this.__wbg_ptr, ptr0, len0);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    is_path_editing() {
        const ret = wasm.app_is_path_editing(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @returns {boolean}
     */
    is_path_closed() {
        const ret = wasm.app_is_path_closed(this.__wbg_ptr);
        return ret !== 0;
    }
    close_editing_path() {
        wasm.app_close_editing_path(this.__wbg_ptr);
    }
    finish_path_editing() {
        wasm.app_finish_path_editing(this.__wbg_ptr);
    }
    /**
     * @param {string | null} [id]
     */
    set_editing_id(id) {
        var ptr0 = isLikeNone(id) ? 0 : passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.app_set_editing_id(this.__wbg_ptr, ptr0, len0);
    }
}

const ColorFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_color_free(ptr >>> 0, 1));

export class Color {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Color.prototype);
        obj.__wbg_ptr = ptr;
        ColorFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ColorFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_color_free(ptr, 0);
    }
    /**
     * @returns {number}
     */
    get r() {
        const ret = wasm.__wbg_get_color_r(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set r(arg0) {
        wasm.__wbg_set_color_r(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get g() {
        const ret = wasm.__wbg_get_color_g(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set g(arg0) {
        wasm.__wbg_set_color_g(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get b() {
        const ret = wasm.__wbg_get_color_b(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set b(arg0) {
        wasm.__wbg_set_color_b(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get a() {
        const ret = wasm.__wbg_get_color_a(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set a(arg0) {
        wasm.__wbg_set_color_a(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {string}
     */
    to_rgb_hex() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = wasm.color_to_rgb_hex(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return getStringFromWasm0(ret[0], ret[1]);
        } finally {
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const StyleFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_style_free(ptr >>> 0, 1));

export class Style {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(Style.prototype);
        obj.__wbg_ptr = ptr;
        StyleFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StyleFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_style_free(ptr, 0);
    }
    /**
     * @returns {FillType}
     */
    get fill_type() {
        const ret = wasm.__wbg_get_style_fill_type(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {FillType} arg0
     */
    set fill_type(arg0) {
        wasm.__wbg_set_style_fill_type(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {Color}
     */
    get fill_color() {
        const ret = wasm.__wbg_get_style_fill_color(this.__wbg_ptr);
        return Color.__wrap(ret);
    }
    /**
     * @param {Color} arg0
     */
    set fill_color(arg0) {
        _assertClass(arg0, Color);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_style_fill_color(this.__wbg_ptr, ptr0);
    }
    /**
     * @returns {StrokeType}
     */
    get stroke_type() {
        const ret = wasm.__wbg_get_style_stroke_type(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {StrokeType} arg0
     */
    set stroke_type(arg0) {
        wasm.__wbg_set_style_stroke_type(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {Color}
     */
    get stroke_color() {
        const ret = wasm.__wbg_get_style_stroke_color(this.__wbg_ptr);
        return Color.__wrap(ret);
    }
    /**
     * @param {Color} arg0
     */
    set stroke_color(arg0) {
        _assertClass(arg0, Color);
        var ptr0 = arg0.__destroy_into_raw();
        wasm.__wbg_set_style_stroke_color(this.__wbg_ptr, ptr0);
    }
    /**
     * @returns {number}
     */
    get stroke_width() {
        const ret = wasm.__wbg_get_style_stroke_width(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {number} arg0
     */
    set stroke_width(arg0) {
        wasm.__wbg_set_style_stroke_width(this.__wbg_ptr, arg0);
    }
    /**
     * @returns {number}
     */
    get text_size() {
        const ret = wasm.__wbg_get_style_text_size(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
     * @param {number} arg0
     */
    set text_size(arg0) {
        wasm.__wbg_set_style_text_size(this.__wbg_ptr, arg0);
    }
}

export function __wbg_activeTexture_460f2e367e813fb0(arg0, arg1) {
    arg0.activeTexture(arg1 >>> 0);
};

export function __wbg_alert_bd1726892adb91f2(arg0, arg1) {
    alert(getStringFromWasm0(arg0, arg1));
};

export function __wbg_appendChild_8204974b7328bf98() { return handleError(function (arg0, arg1) {
    const ret = arg0.appendChild(arg1);
    return ret;
}, arguments) };

export function __wbg_attachShader_3d4eb6af9e3e7bd1(arg0, arg1, arg2) {
    arg0.attachShader(arg1, arg2);
};

export function __wbg_bindBuffer_309c9a6c21826cf5(arg0, arg1, arg2) {
    arg0.bindBuffer(arg1 >>> 0, arg2);
};

export function __wbg_bindTexture_a6e795697f49ebd1(arg0, arg1, arg2) {
    arg0.bindTexture(arg1 >>> 0, arg2);
};

export function __wbg_bindVertexArray_6b4b88581064b71f(arg0, arg1) {
    arg0.bindVertexArray(arg1);
};

export function __wbg_blendFunc_c3b74be5a39c665f(arg0, arg1, arg2) {
    arg0.blendFunc(arg1 >>> 0, arg2 >>> 0);
};

export function __wbg_body_942ea927546a04ba(arg0) {
    const ret = arg0.body;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_bufferData_463178757784fcac(arg0, arg1, arg2, arg3) {
    arg0.bufferData(arg1 >>> 0, arg2, arg3 >>> 0);
};

export function __wbg_bufferSubData_4e973eefe9236d04(arg0, arg1, arg2, arg3) {
    arg0.bufferSubData(arg1 >>> 0, arg2, arg3);
};

export function __wbg_buffer_609cc3eee51ed158(arg0) {
    const ret = arg0.buffer;
    return ret;
};

export function __wbg_call_672a4d21634d4a24() { return handleError(function (arg0, arg1) {
    const ret = arg0.call(arg1);
    return ret;
}, arguments) };

export function __wbg_clearColor_d39507085c98a678(arg0, arg1, arg2, arg3, arg4) {
    arg0.clearColor(arg1, arg2, arg3, arg4);
};

export function __wbg_clear_62b9037b892f6988(arg0, arg1) {
    arg0.clear(arg1 >>> 0);
};

export function __wbg_compileShader_0ad770bbdbb9de21(arg0, arg1) {
    arg0.compileShader(arg1);
};

export function __wbg_createBuffer_9886e84a67b68c89(arg0) {
    const ret = arg0.createBuffer();
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_createElement_8c9931a732ee2fea() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.createElement(getStringFromWasm0(arg1, arg2));
    return ret;
}, arguments) };

export function __wbg_createProgram_da203074cafb1038(arg0) {
    const ret = arg0.createProgram();
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_createShader_983150fb1243ee56(arg0, arg1) {
    const ret = arg0.createShader(arg1 >>> 0);
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_createTexture_bfaa54c0cd22e367(arg0) {
    const ret = arg0.createTexture();
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_createVertexArray_e435029ae2660efd(arg0) {
    const ret = arg0.createVertexArray();
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_debug_e17b51583ca6a632(arg0, arg1, arg2, arg3) {
    console.debug(arg0, arg1, arg2, arg3);
};

export function __wbg_document_d249400bd7bd996d(arg0) {
    const ret = arg0.document;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_drawElements_65cb4b099bd7d4ac(arg0, arg1, arg2, arg3, arg4) {
    arg0.drawElements(arg1 >>> 0, arg2, arg3 >>> 0, arg4);
};

export function __wbg_drawImage_dfdde1887a169a24() { return handleError(function (arg0, arg1, arg2, arg3) {
    arg0.drawImage(arg1, arg2, arg3);
}, arguments) };

export function __wbg_enableVertexAttribArray_93c3d406a41ad6c7(arg0, arg1) {
    arg0.enableVertexAttribArray(arg1 >>> 0);
};

export function __wbg_enable_51114837e05ee280(arg0, arg1) {
    arg0.enable(arg1 >>> 0);
};

export function __wbg_entries_3265d4158b33e5dc(arg0) {
    const ret = Object.entries(arg0);
    return ret;
};

export function __wbg_error_7534b8e9a36f1ab4(arg0, arg1) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg0;
        deferred0_1 = arg1;
        console.error(getStringFromWasm0(arg0, arg1));
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
};

export function __wbg_error_80de38b3f7cc3c3c(arg0, arg1, arg2, arg3) {
    console.error(arg0, arg1, arg2, arg3);
};

export function __wbg_fillRect_c38d5d56492a2368(arg0, arg1, arg2, arg3, arg4) {
    arg0.fillRect(arg1, arg2, arg3, arg4);
};

export function __wbg_getContext_e9cf379449413580() { return handleError(function (arg0, arg1, arg2) {
    const ret = arg0.getContext(getStringFromWasm0(arg1, arg2));
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_getContext_fc19859df6331073() { return handleError(function (arg0, arg1, arg2, arg3) {
    const ret = arg0.getContext(getStringFromWasm0(arg1, arg2), arg3);
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_getItem_17f98dee3b43fa7e() { return handleError(function (arg0, arg1, arg2, arg3) {
    const ret = arg1.getItem(getStringFromWasm0(arg2, arg3));
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg_getParameter_e3429f024018310f() { return handleError(function (arg0, arg1) {
    const ret = arg0.getParameter(arg1 >>> 0);
    return ret;
}, arguments) };

export function __wbg_getProgramInfoLog_a998105a680059db(arg0, arg1, arg2) {
    const ret = arg1.getProgramInfoLog(arg2);
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_getProgramParameter_360f95ff07ac068d(arg0, arg1, arg2) {
    const ret = arg0.getProgramParameter(arg1, arg2 >>> 0);
    return ret;
};

export function __wbg_getShaderInfoLog_f59c3112acc6e039(arg0, arg1, arg2) {
    const ret = arg1.getShaderInfoLog(arg2);
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_getShaderParameter_511b5f929074fa31(arg0, arg1, arg2) {
    const ret = arg0.getShaderParameter(arg1, arg2 >>> 0);
    return ret;
};

export function __wbg_getUniformLocation_657a2b6d102bd126(arg0, arg1, arg2, arg3) {
    const ret = arg0.getUniformLocation(arg1, getStringFromWasm0(arg2, arg3));
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_get_67b2ba62fc30de12() { return handleError(function (arg0, arg1) {
    const ret = Reflect.get(arg0, arg1);
    return ret;
}, arguments) };

export function __wbg_get_b9b93047fe3cf45b(arg0, arg1) {
    const ret = arg0[arg1 >>> 0];
    return ret;
};

export function __wbg_getwithrefkey_1dc361bd10053bfe(arg0, arg1) {
    const ret = arg0[arg1];
    return ret;
};

export function __wbg_height_838cee19ba8597db(arg0) {
    const ret = arg0.height;
    return ret;
};

export function __wbg_info_033d8b8a0838f1d3(arg0, arg1, arg2, arg3) {
    console.info(arg0, arg1, arg2, arg3);
};

export function __wbg_instanceof_ArrayBuffer_e14585432e3737fc(arg0) {
    let result;
    try {
        result = arg0 instanceof ArrayBuffer;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_CanvasRenderingContext2d_df82a4d3437bf1cc(arg0) {
    let result;
    try {
        result = arg0 instanceof CanvasRenderingContext2D;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_HtmlCanvasElement_2ea67072a7624ac5(arg0) {
    let result;
    try {
        result = arg0 instanceof HTMLCanvasElement;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Uint8Array_17156bcf118086a9(arg0) {
    let result;
    try {
        result = arg0 instanceof Uint8Array;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_WebGl2RenderingContext_2b6045efeb76568d(arg0) {
    let result;
    try {
        result = arg0 instanceof WebGL2RenderingContext;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Window_def73ea0955fc569(arg0) {
    let result;
    try {
        result = arg0 instanceof Window;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_isSafeInteger_343e2beeeece1bb0(arg0) {
    const ret = Number.isSafeInteger(arg0);
    return ret;
};

export function __wbg_is_c7481c65e7e5df9e(arg0, arg1) {
    const ret = Object.is(arg0, arg1);
    return ret;
};

export function __wbg_length_a446193dc22c12f8(arg0) {
    const ret = arg0.length;
    return ret;
};

export function __wbg_length_e2d2a49132c1b256(arg0) {
    const ret = arg0.length;
    return ret;
};

export function __wbg_linkProgram_067ee06739bdde81(arg0, arg1) {
    arg0.linkProgram(arg1);
};

export function __wbg_localStorage_1406c99c39728187() { return handleError(function (arg0) {
    const ret = arg0.localStorage;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
}, arguments) };

export function __wbg_log_cad59bb680daec67(arg0, arg1, arg2, arg3) {
    console.log(arg0, arg1, arg2, arg3);
};

export function __wbg_new_405e22f390576ce2() {
    const ret = new Object();
    return ret;
};

export function __wbg_new_5e0be73521bc8c17() {
    const ret = new Map();
    return ret;
};

export function __wbg_new_78feb108b6472713() {
    const ret = new Array();
    return ret;
};

export function __wbg_new_8a6f238a6ece86ea() {
    const ret = new Error();
    return ret;
};

export function __wbg_new_a12002a7f91c75be(arg0) {
    const ret = new Uint8Array(arg0);
    return ret;
};

export function __wbg_newnoargs_105ed471475aaf50(arg0, arg1) {
    const ret = new Function(getStringFromWasm0(arg0, arg1));
    return ret;
};

export function __wbg_newwithbyteoffsetandlength_d4a86622320ea258(arg0, arg1, arg2) {
    const ret = new Uint16Array(arg0, arg1 >>> 0, arg2 >>> 0);
    return ret;
};

export function __wbg_newwithbyteoffsetandlength_e6b7e69acd4c7354(arg0, arg1, arg2) {
    const ret = new Float32Array(arg0, arg1 >>> 0, arg2 >>> 0);
    return ret;
};

export function __wbg_now_d18023d54d4e5500(arg0) {
    const ret = arg0.now();
    return ret;
};

export function __wbg_onWasmEvent_6e353ca58ed6f2ec(arg0, arg1) {
    onWasmEvent(getStringFromWasm0(arg0, arg1));
};

export function __wbg_performance_c185c0cdc2766575(arg0) {
    const ret = arg0.performance;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_pixelStorei_c8520e4b46f4a973(arg0, arg1, arg2) {
    arg0.pixelStorei(arg1 >>> 0, arg2);
};

export function __wbg_requestImageTexture_b043bdd4be96a252(arg0, arg1) {
    window.requestImageTexture(getStringFromWasm0(arg0, arg1));
};

export function __wbg_setItem_212ecc915942ab0a() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    arg0.setItem(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
}, arguments) };

export function __wbg_set_37837023f3d740e8(arg0, arg1, arg2) {
    arg0[arg1 >>> 0] = arg2;
};

export function __wbg_set_3f1d0b984ed272ed(arg0, arg1, arg2) {
    arg0[arg1] = arg2;
};

export function __wbg_set_65595bdd868b3009(arg0, arg1, arg2) {
    arg0.set(arg1, arg2 >>> 0);
};

export function __wbg_set_8fc6bf8a5b1071d1(arg0, arg1, arg2) {
    const ret = arg0.set(arg1, arg2);
    return ret;
};

export function __wbg_setclassName_6bdd0705e646d028(arg0, arg1, arg2) {
    arg0.className = getStringFromWasm0(arg1, arg2);
};

export function __wbg_setfillStyle_2205fca942c641ba(arg0, arg1, arg2) {
    arg0.fillStyle = getStringFromWasm0(arg1, arg2);
};

export function __wbg_setheight_da683a33fa99843c(arg0, arg1) {
    arg0.height = arg1 >>> 0;
};

export function __wbg_setwidth_c5fed9f5e7f0b406(arg0, arg1) {
    arg0.width = arg1 >>> 0;
};

export function __wbg_shaderSource_72d3e8597ef85b67(arg0, arg1, arg2, arg3) {
    arg0.shaderSource(arg1, getStringFromWasm0(arg2, arg3));
};

export function __wbg_stack_0ed75d68575b0f3c(arg0, arg1) {
    const ret = arg1.stack;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_static_accessor_GLOBAL_88a902d13a557d07() {
    const ret = typeof global === 'undefined' ? null : global;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0() {
    const ret = typeof globalThis === 'undefined' ? null : globalThis;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_static_accessor_SELF_37c5d418e4bf5819() {
    const ret = typeof self === 'undefined' ? null : self;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_static_accessor_WINDOW_5de37043a91a9c40() {
    const ret = typeof window === 'undefined' ? null : window;
    return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
};

export function __wbg_texImage2D_06281e677e3f6909() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10) {
    arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9 === 0 ? undefined : getArrayU8FromWasm0(arg9, arg10));
}, arguments) };

export function __wbg_texImage2D_f1dc2cc64f0d7e5e() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
    arg0.texImage2D(arg1 >>> 0, arg2, arg3, arg4 >>> 0, arg5 >>> 0, arg6);
}, arguments) };

export function __wbg_texParameteri_8112b26b3c360b7e(arg0, arg1, arg2, arg3) {
    arg0.texParameteri(arg1 >>> 0, arg2 >>> 0, arg3);
};

export function __wbg_texSubImage2D_89d024022529730a() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7, arg8, arg9, arg10) {
    arg0.texSubImage2D(arg1 >>> 0, arg2, arg3, arg4, arg5, arg6, arg7 >>> 0, arg8 >>> 0, arg9 === 0 ? undefined : getArrayU8FromWasm0(arg9, arg10));
}, arguments) };

export function __wbg_toDataURL_ca84be9d3afd64db() { return handleError(function (arg0, arg1, arg2, arg3) {
    const ret = arg1.toDataURL(getStringFromWasm0(arg2, arg3));
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}, arguments) };

export function __wbg_uniform1iv_337c4a74e31ddc15(arg0, arg1, arg2, arg3) {
    arg0.uniform1iv(arg1, getArrayI32FromWasm0(arg2, arg3));
};

export function __wbg_uniformMatrix3fv_3df529aab93cf902(arg0, arg1, arg2, arg3, arg4) {
    arg0.uniformMatrix3fv(arg1, arg2 !== 0, getArrayF32FromWasm0(arg3, arg4));
};

export function __wbg_useProgram_9b2660f7bb210471(arg0, arg1) {
    arg0.useProgram(arg1);
};

export function __wbg_vertexAttribPointer_550dc34903e3d1ea(arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
    arg0.vertexAttribPointer(arg1 >>> 0, arg2, arg3 >>> 0, arg4 !== 0, arg5, arg6);
};

export function __wbg_viewport_e615e98f676f2d39(arg0, arg1, arg2, arg3, arg4) {
    arg0.viewport(arg1, arg2, arg3, arg4);
};

export function __wbg_warn_aaf1f4664a035bd6(arg0, arg1, arg2, arg3) {
    console.warn(arg0, arg1, arg2, arg3);
};

export function __wbg_width_5dde457d606ba683(arg0) {
    const ret = arg0.width;
    return ret;
};

export function __wbindgen_as_number(arg0) {
    const ret = +arg0;
    return ret;
};

export function __wbindgen_bigint_from_i64(arg0) {
    const ret = arg0;
    return ret;
};

export function __wbindgen_bigint_from_u64(arg0) {
    const ret = BigInt.asUintN(64, arg0);
    return ret;
};

export function __wbindgen_bigint_get_as_i64(arg0, arg1) {
    const v = arg1;
    const ret = typeof(v) === 'bigint' ? v : undefined;
    getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
};

export function __wbindgen_boolean_get(arg0) {
    const v = arg0;
    const ret = typeof(v) === 'boolean' ? (v ? 1 : 0) : 2;
    return ret;
};

export function __wbindgen_debug_string(arg0, arg1) {
    const ret = debugString(arg1);
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbindgen_error_new(arg0, arg1) {
    const ret = new Error(getStringFromWasm0(arg0, arg1));
    return ret;
};

export function __wbindgen_in(arg0, arg1) {
    const ret = arg0 in arg1;
    return ret;
};

export function __wbindgen_init_externref_table() {
    const table = wasm.__wbindgen_export_2;
    const offset = table.grow(4);
    table.set(0, undefined);
    table.set(offset + 0, undefined);
    table.set(offset + 1, null);
    table.set(offset + 2, true);
    table.set(offset + 3, false);
    ;
};

export function __wbindgen_is_bigint(arg0) {
    const ret = typeof(arg0) === 'bigint';
    return ret;
};

export function __wbindgen_is_null(arg0) {
    const ret = arg0 === null;
    return ret;
};

export function __wbindgen_is_object(arg0) {
    const val = arg0;
    const ret = typeof(val) === 'object' && val !== null;
    return ret;
};

export function __wbindgen_is_string(arg0) {
    const ret = typeof(arg0) === 'string';
    return ret;
};

export function __wbindgen_is_undefined(arg0) {
    const ret = arg0 === undefined;
    return ret;
};

export function __wbindgen_jsval_eq(arg0, arg1) {
    const ret = arg0 === arg1;
    return ret;
};

export function __wbindgen_jsval_loose_eq(arg0, arg1) {
    const ret = arg0 == arg1;
    return ret;
};

export function __wbindgen_memory() {
    const ret = wasm.memory;
    return ret;
};

export function __wbindgen_number_get(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'number' ? obj : undefined;
    getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
};

export function __wbindgen_number_new(arg0) {
    const ret = arg0;
    return ret;
};

export function __wbindgen_string_get(arg0, arg1) {
    const obj = arg1;
    const ret = typeof(obj) === 'string' ? obj : undefined;
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbindgen_string_new(arg0, arg1) {
    const ret = getStringFromWasm0(arg0, arg1);
    return ret;
};

export function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

